import { Component, forwardRef, ChangeDetectionStrategy, EventEmitter, Input, Output, HostBinding, signal } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'tt-toggleswitch',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './toggleswitch.component.html',
  styleUrls: ['./toggleswitch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleSwitchComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleSwitchComponent implements ControlValueAccessor {
  protected _checked = signal(false);

  @Input()
  public get checked(): boolean {
    return this._checked();
  }
  public set checked(value: boolean) {
    this._checked.set(value);
  }

  @Input() public disabled?: boolean = false;

  @Input() public variant: 'regular' | 'large' = 'regular';

  @Input() public label = '';

  @HostBinding('class')
  public get hostClasses(): string {
    return `tt-toggleswitch--${this.variant}`;
  }

  @Output() public valueChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange: (value: boolean) => void = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouch: () => void = () => {};

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public writeValue(value: boolean): void {
    this.checked = value;
  }

  public onModelChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.checked = target.checked;

    this.onChange(this.checked);
    this.valueChange.emit(this.checked);
  }
}
